// File: frontend/src/mocks/reinsurance/reportingData.js

export const mockGenerateReportResponse = {
  success: true,
  data: {
    report_id: "rep1-2a3b-4c5d-6e7f-8g9h0i1j2k3l",
    report_type: "portfolio_performance",
    report_date: "2025-05-03T10:30:00Z",
    report_period: {
      start_date: "2025-01-01T00:00:00Z",
      end_date: "2025-04-30T23:59:59Z"
    },
    portfolio_metrics: {
      total_contracts: 42,
      total_limit: 630000000,
      total_premium: 94500000,
      total_incurred_losses: 18750000,
      loss_ratio: 19.84,
      combined_ratio: 49.84,
      return_on_capital: 10.1
    },
    performance_by_contract_type: {
      property: {
        count: 25,
        total_limit: 375000000,
        total_premium: 56250000,
        total_incurred_losses: 10000000,
        loss_ratio: 17.78
      },
      specialty: {
        count: 10,
        total_limit: 150000000,
        total_premium: 22500000,
        total_incurred_losses: 5000000,
        loss_ratio: 22.22
      },
      parametric: {
        count: 5,
        total_limit: 75000000,
        total_premium: 11250000,
        total_incurred_losses: 2500000,
        loss_ratio: 22.22
      },
      ilw: {
        count: 2,
        total_limit: 30000000,
        total_premium: 4500000,
        total_incurred_losses: 1250000,
        loss_ratio: 27.78
      }
    },
    performance_by_territory: {
      US: {
        total_limit: 400000000,
        total_premium: 60000000,
        total_incurred_losses: 12500000,
        loss_ratio: 20.83
      },
      JP: {
        total_limit: 100000000,
        total_premium: 15000000,
        total_incurred_losses: 2500000,
        loss_ratio: 16.67
      },
      CA: {
        total_limit: 50000000,
        total_premium: 7500000,
        total_incurred_losses: 1500000,
        loss_ratio: 20.00
      },
      EU: {
        total_limit: 30000000,
        total_premium: 4500000,
        total_incurred_losses: 1000000,
        loss_ratio: 22.22
      },
      GLOBAL: {
        total_limit: 50000000,
        total_premium: 7500000,
        total_incurred_losses: 1250000,
        loss_ratio: 16.67
      }
    },
    top_performing_contracts: [
      {
        contract_id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p",
        contract_number: "RIL-240501-123",
        contract_type: "parametric",
        cedent_name: "Atlantic Re",
        premium: 3000000,
        incurred_losses: 2500000,
        loss_ratio: 83.33,
        return_on_capital: 3.13
      },
      {
        contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p",
        contract_number: "RIL-240422-456",
        contract_type: "specialty",
        cedent_name: "Pacific Mutual",
        premium: 1500000,
        incurred_losses: 5000000,
        loss_ratio: 333.33,
        return_on_capital: -43.75
      },
      {
        contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
        contract_number: "RIL-240315-789",
        contract_type: "property",
        cedent_name: "Global Insurance Co.",
        premium: 2250000,
        incurred_losses: 5000000,
        loss_ratio: 222.22,
        return_on_capital: -22.92
      }
    ]
  }
};

export const mockInvestorReportResponse = {
  success: true,
  data: {
    report_date: "2025-05-03T10:30:00Z",
    investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
    investor_name: "ILS Fund Alpha",
    capital_position: {
      total_capital: 100000000,
      total_allocated: 75000000,
      total_available: 25000000,
      allocation_percentage: 75
    },
    performance_metrics: {
      expected_return: 13.5,
      actual_return: 10.2,
      loss_ratio: 25,
      combined_ratio: 55
    },
    allocation_by_contract_type: {
      property: {
        amount: 45000000,
        percentage: 60,
        expected_return: 12.8,
        actual_return: 9.5
      },
      specialty: {
        amount: 20000000,
        percentage: 26.67,
        expected_return: 14.2,
        actual_return: 10.8
      },
      parametric: {
        amount: 10000000,
        percentage: 13.33,
        expected_return: 15.3,
        actual_return: 12.5
      }
    },
    allocation_by_peril: {
      hurricane: {
        amount: 30000000,
        percentage: 40,
        expected_return: 13.2,
        actual_return: 9.8
      },
      earthquake: {
        amount: 22500000,
        percentage: 30,
        expected_return: 14.5,
        actual_return: 11.2
      },
      flood: {
        amount: 7500000,
        percentage: 10,
        expected_return: 12.8,
        actual_return: 10.5
      },
      wildfire: {
        amount: 7500000,
        percentage: 10,
        expected_return: 13.5,
        actual_return: 9.2
      },
      marine: {
        amount: 7500000,
        percentage: 10,
        expected_return: 14.2,
        actual_return: 10.8
      }
    },
    top_performing_allocations: [
      {
        contract_id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p",
        contract_number: "RIL-240501-123",
        contract_type: "parametric",
        cedent_name: "Atlantic Re",
        amount: 6000000,
        percentage: 30,
        expected_return: 15.3,
        actual_return: 12.5
      },
      {
        contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p",
        contract_number: "RIL-240422-456",
        contract_type: "specialty",
        cedent_name: "Pacific Mutual",
        amount: 5000000,
        percentage: 50,
        expected_return: 14.2,
        actual_return: 10.8
      },
      {
        contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
        contract_number: "RIL-240315-789",
        contract_type: "property",
        cedent_name: "Global Insurance Co.",
        amount: 8000000,
        percentage: 53.33,
        expected_return: 12.5,
        actual_return: 9.5
      }
    ],
    claims_impact: {
      total_claims: 5,
      total_incurred: 12500000,
      total_paid: 3750000,
      total_reserved: 8750000,
      impact_on_return: -3.3
    }
  }
};

export const mockRegulatoryReportResponse = {
  success: true,
  data: {
    report_date: "2025-05-03T10:30:00Z",
    regulatory_regime: "bermuda_bma",
    reporting_period: "quarterly",
    solvency_metrics: {
      total_assets: 100000000,
      total_liabilities: 8750000,
      solvency_margin: 91250000,
      solvency_ratio: 11.43
    },
    underwriting_metrics: {
      gross_written_premium: 94500000,
      net_written_premium: 94500000,
      net_earned_premium: 31500000,
      net_incurred_losses: 18750000,
      loss_ratio: 19.84
    },
    investment_metrics: {
      total_investments: 100000000,
      investment_income: 1250000,
      investment_yield: 1.25
    },
    contract_summary: {
      total_contracts: 42,
      total_limit: 630000000,
      contracts_by_type: {
        property: {
          count: 25,
          total_limit: 375000000,
          total_premium: 56250000
        },
        specialty: {
          count: 10,
          total_limit: 150000000,
          total_premium: 22500000
        },
        parametric: {
          count: 5,
          total_limit: 75000000,
          total_premium: 11250000
        },
        ilw: {
          count: 2,
          total_limit: 30000000,
          total_premium: 4500000
        }
      }
    },
    claim_summary: {
      total_claims: 7,
      total_incurred: 18750000,
      total_paid: 9375000,
      total_reserved: 9375000
    }
  }
};